import { SettingConst } from '@faire/web-api--source/types';

/**
 * Geo-based setting controlling Launch with faire
 */
export const LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY =
  'LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY' as SettingConst<
    'LAUNCH_WITH_FAIRE_ENABLED_FOR_RETAILER_COUNTRY',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
